export default "__VITE_ASSET__DHGwssKr__"